import React from "react";

export function FolderPageContent({ pageDataset, setPageDataset, pageId }) {

  const handleAddRow = () => {
    const newRow = { name: "", value: "" }; // Example row structure
    setPageDataset([...pageDataset, newRow]);
  };

  const handleDeleteRow = (index) => {
    setPageDataset(pageDataset.filter((_, i) => i !== index));
  };

  const moveRowUp = (index) => {
    if (index === 0) return;
    const newDataset = [...pageDataset];
    [newDataset[index - 1], newDataset[index]] = [newDataset[index], newDataset[index - 1]];
    setPageDataset(newDataset);
  };

  const moveRowDown = (index) => {
    if (index === pageDataset.length - 1) return;
    const newDataset = [...pageDataset];
    [newDataset[index], newDataset[index + 1]] = [newDataset[index + 1], newDataset[index]];
    setPageDataset(newDataset);
  };

  return (
    <div>
      <h3>Folder & File Management</h3>
      <button onClick={handleAddRow}>Add Row</button>

      {pageDataset.length === 0 ? (
        <div>No items yet.</div>
      ) : (
        <table style={{ borderCollapse: "collapse", width: "100%", marginTop: "1rem" }}>
          <thead>
            <tr>
              {Object.keys(pageDataset[0]).map((col, i) => (
                <th key={i} style={{ border: "1px solid #ccc", padding: "0.5rem", background: "#f3f3f3" }}>
                  {col.name}
                </th>
              ))}
              <th style={{ border: "1px solid #ccc", padding: "0.5rem", background: "#f3f3f3" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pageDataset.map((row, i) => (
              <tr key={i}>
                {Object.values(row).map((val, j) => (
                  <td key={j} style={{ border: "1px solid #ccc", padding: "0.5rem" }}>{val}</td>
                ))}
                <td style={{ border: "1px solid #ccc", padding: "0.5rem" }}>
                  <button onClick={() => moveRowUp(i)}>↑</button>
                  <button onClick={() => moveRowDown(i)}>↓</button>
                  <button onClick={() => handleDeleteRow(i)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
